import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21530ef3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column gap-5" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-header border-0 pt-6" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_6 = { class: "svg-icon svg-icon-1 position-absolute ms-4" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "card-body pt-0" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "d-flex align-items-center justify-content-end gap-2" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "svg-icon svg-icon-3 m-0" }
const _hoisted_17 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_18 = ["disabled"]
const _hoisted_19 = {
  key: 0,
  class: "spinner-border spinner-border-sm align-middle"
}
const _hoisted_20 = {
  key: 1,
  class: "bi bi-three-dots fs-3"
}
const _hoisted_21 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary w-auto min-w-100px fw-bold",
  "data-kt-menu": "true"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-75" }, null, -1))
const _hoisted_23 = { class: "menu-item px-3 mb-3" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = {
  key: 0,
  class: "menu-item px-3 mb-3"
}
const _hoisted_26 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_permission_common = _resolveComponent("permission-common")!
  const _component_MBDatatable = _resolveComponent("MBDatatable")!
  const _component_update_invoice = _resolveComponent("update-invoice")!
  const _component_import_model = _resolveComponent("import-model")!
  const _directive_auth = _resolveDirective("auth")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen021.svg" })
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchItems())),
                class: "form-control form-control-solid w-250px ps-14",
                placeholder: _ctx.t('common.search')
              }, null, 40, _hoisted_7), [
                [_vModelText, _ctx.search]
              ]),
              _withDirectives(_createElementVNode("span", {
                class: "svg-icon svg-icon-1 position-absolute top-50 end-0 mr-2 translate-middle cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeSearch && _ctx.removeSearch(...args)))
              }, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
              ], 512), [
                [_vShow, _ctx.search != '']
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_MBDatatable, {
            loading: _ctx.loading,
            "table-data": _ctx.tableData,
            "table-header": _ctx.tableHeader,
            order: "desc",
            "enable-items-per-page-dropdown": true,
            "current-page": _ctx.currentPage,
            total: _ctx.total,
            "rows-per-page": _ctx.pageSize,
            onSelectChange: _ctx.onRowsSelectChange,
            onCurrentChange: _ctx.onCurrentPageChange,
            onItemsPerPageChange: _ctx.onRowsPerPageChange,
            onSort: _ctx.onColumnSort
          }, {
            "cell-invoice_number": _withCtx(({ row: item }) => [
              (item.credit_note_number)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "cursor-pointer text-primary",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#modal_update_merchant_credit_notes",
                    onClick: 
                () => {
                  _ctx.setInvoiceModalReadOnly(true), _ctx.handleInvoice(item);
                }
              
                  }, _toDisplayString(item.credit_note_number), 9, _hoisted_9))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "--"))
            ]),
            "cell-invoice_date": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.credit_note_date ? _ctx.formatDate(item.credit_note_date) : "--"), 1)
            ]),
            "cell-merchant": _withCtx(({ row: item }) => [
              _createTextVNode(_toDisplayString(item.__show.merchant_name || "--"), 1)
            ]),
            "cell-status": _withCtx(({ row: item }) => [
              (item.__show.status)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: _normalizeClass(["badge text-uppercase ms-2", _ctx.getMerchantOrderInvoiceStatus(item.status)])
                  }, _toDisplayString(item.__show.status), 3))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "--"))
            ]),
            "cell-total_amount": _withCtx(({ row: item }) => [
              (item.total_amount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.currency == "CNY"
                  ? _ctx.$currency.currency(item.total_amount, 2, ".", "", "￥ ")
                  : _ctx.$currency.currency(item.total_amount, 2, ",", ".", "€ ")), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_13, "--"))
            ]),
            "cell-actions": _withCtx(({ row: item }) => [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                  default: _withCtx(() => [
                    (item.__show.invoice_file != '')
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                          onClick: ($event: any) => (_ctx.handlePreview(item))
                        }, [
                          _createElementVNode("span", _hoisted_16, [
                            (!item.previewDisabled)
                              ? (_openBlock(), _createBlock(_component_inline_svg_icon, {
                                  key: 0,
                                  src: "media/icons/duotune/coding/cod007.svg"
                                }))
                              : (_openBlock(), _createElementBlock("span", _hoisted_17))
                          ])
                        ], 8, _hoisted_15))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024),
                (
                  _ctx.checkPermissionFlag(
                    { auth: ['export'] },
                    item.__show.invoice_file != ''
                  ) ||
                  _ctx.checkPermissionFlag({ auth: ['update'] }) ||
                  _ctx.checkPermissionFlag(
                    { auth: ['delete'] },
                    item.status === _ctx.InvoiceStatus.Pending
                  )
                )
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                      "data-kt-menu-trigger": "click",
                      "data-kt-menu-placement": "bottom-end",
                      "data-kt-menu-flip": "top-end",
                      disabled: 
                  _ctx.loading || item.downloadDisabled || item.deleteDisabled
                
                    }, [
                      (_ctx.loading || item.downloadDisabled || item.deleteDisabled)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_19))
                        : (_openBlock(), _createElementBlock("i", _hoisted_20))
                    ], 8, _hoisted_18))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_permission_common, { role: { auth: ['update'] } }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", {
                          class: "menu-link px-3",
                          "data-bs-toggle": "modal",
                          "data-bs-target": "#modal_update_merchant_credit_notes",
                          onClick: 
                        () => {
                          _ctx.setInvoiceModalReadOnly(false), _ctx.handleInvoice(item);
                        }
                      ,
                          style: {"font-size":"normal"}
                        }, _toDisplayString(_ctx.t("common.edit")), 9, _hoisted_24)
                      ])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_permission_common, { role: { auth: ['export'] } }, {
                    default: _withCtx(() => [
                      (item.__show.invoice_file != '')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("div", {
                              class: "menu-link px-3",
                              onClick: ($event: any) => (_ctx.handleDownload(item)),
                              style: {"font-size":"normal"}
                            }, _toDisplayString(_ctx.t("common.download")), 9, _hoisted_26)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ])), [
                [_directive_auth, { auth: ['export', 'update', 'delete'] }]
              ])
            ]),
            _: 1
          }, 8, ["loading", "table-data", "table-header", "current-page", "total", "rows-per-page", "onSelectChange", "onCurrentChange", "onItemsPerPageChange", "onSort"])
        ])
      ])
    ]),
    _createVNode(_component_update_invoice, {
      id: Number(_ctx.options.invoiceId),
      parentId: Number(_ctx.$route.params.id),
      onResetForm: _ctx.handleReset,
      onUpdateList: _ctx.updateList,
      readonly: _ctx.invoiceModalReadOnly
    }, null, 8, ["id", "parentId", "onResetForm", "onUpdateList", "readonly"]),
    _createVNode(_component_import_model, { onUpdateList: _ctx.updateList }, null, 8, ["onUpdateList"])
  ], 64))
}